<template>
    <div class="navbar">
        <div class="viability-logo" @click="_navigateHome">
            <img :src="logo" alt="Viability Logo">
        </div>
        <el-menu :default-active="activeIndex" class="main-menu" mode="horizontal" @select="handleSelect">
            <el-menu-item @click="handleLogout" class="logout-button">
                Logout
            </el-menu-item>
        </el-menu>
    </div>
</template>

<script>
    import logo from '@/assets/logo.svg';

    export default {
        data: () => ({
            activeIndex: "1",
            logo
        }),
        methods: {
            handleSelect(key, path) {
            },
            handleLogout() {
                this.$store.dispatch('user/LogOut').then(() => {
                    this.$router.push('/login');
                });
            },
            _navigateHome() {
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    @import '~@/styles/layout';
    @import '~@/styles/variables';

    .navbar {
        display : flex;

        .viability-logo {
            width            : $sidebar-width;
            background-color : $blue-black;
            display          : flex;
            align-items      : center;
            justify-content  : center;
            opacity          : 0.9;
            cursor           : pointer;
        }

        .main-menu {
            flex             : 1;
            display          : flex;
            background-color : $blue-black;
            border-bottom    : none;
        }

        .logout-button {
            margin-left : auto;
        }
    }
</style>

